import { render, staticRenderFns } from "./rights-table.vue?vue&type=template&id=731d5fb6"
import script from "./rights-table.vue?vue&type=script&lang=js"
export * from "./rights-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports